import { InsuranceProviderEnum } from './enums/insurance-provider-enum.model';
import { InsuranceRange } from './insurance-range.model';
import { InsuranceType } from './insurance-type.model';

export class Insurance {
  id?: string;
  internalReference: string;
  insuranceCompany: string;
  pulpoCompanyId?: string;
  insuranceProvider?: InsuranceProviderEnum;
  calculatedOnMarginPrice?: boolean;
  maximumDays?: number;
  minimumPassengers?: number;
  maximumPassengers?: number;
  isDeletable?: boolean;
  ranges?: InsuranceRange[];
  types?: InsuranceType[];
  margin?: number;
  // Key: language code (e.g., 'en', 'fr', 'es', 'it'), Value: translated text
  translations?: { [key: string]: { name: string; information: string } };

  constructor() {
    this.internalReference = '';
    this.insuranceCompany = '';
  }
}
